import type { CSSProperties, ReactNode } from 'react'

export const sharedPageBackdropBackgrounds = {
  plain: 'var(--md-page-backdrop-plain, #ffffff)',
  paper: 'var(--md-page-backdrop-paper, #f3f1ec)',
  neutral: 'var(--md-page-backdrop-neutral, #eef1f0)',
} as const

export type SharedPageBackdrop = keyof typeof sharedPageBackdropBackgrounds

export function PageBackdrop({
  variant,
  className = '',
  children,
}: {
  variant: SharedPageBackdrop
  className?: string
  children: ReactNode
}) {
  const style = {
    background: sharedPageBackdropBackgrounds[variant],
  } satisfies CSSProperties

  return (
    <div
      data-md-page-backdrop={variant}
      className={`min-h-screen w-full ${className}`}
      style={style}
    >
      {children}
    </div>
  )
}
